/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../glyph/glyph_icon';
import './text_input_field_content_type';
import '../../../common/currency_codes';
import '../../../common/currency';
import './rich_text';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "component": {
                "nested": {
                  "ButtonDescription": {
                    "fields": {
                      "text": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "style": {
                        "type": ".squareup.bbfrontend.common.component.ButtonDescription.ButtonStyle",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "BUTTON_STYLE_DEFERRED"
                        }
                      },
                      "variant": {
                        "type": ".squareup.bbfrontend.common.component.ButtonDescription.ButtonVariant",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": "BUTTON_VARIANT_DEFERRED"
                        }
                      },
                      "icon": {
                        "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                        "id": 4,
                        "rule": "optional"
                      },
                      "size": {
                        "type": ".squareup.bbfrontend.common.component.ButtonDescription.ButtonSize",
                        "id": 5,
                        "rule": "optional",
                        "options": {
                          "default": "BUTTON_SIZE_DEFERRED"
                        }
                      }
                    },
                    "nested": {
                      "ButtonStyle": {
                        "values": {
                          "BUTTON_STYLE_DEFERRED": 0,
                          "BUTTON_STYLE_PRIMARY": 1,
                          "BUTTON_STYLE_SECONDARY": 2,
                          "BUTTON_STYLE_TERTIARY": 3
                        }
                      },
                      "ButtonVariant": {
                        "values": {
                          "BUTTON_VARIANT_DEFERRED": 0,
                          "BUTTON_VARIANT_NORMAL": 1,
                          "BUTTON_VARIANT_DESTRUCTIVE": 2
                        }
                      },
                      "ButtonSize": {
                        "values": {
                          "BUTTON_SIZE_DEFERRED": 0,
                          "BUTTON_SIZE_SMALL": 1,
                          "BUTTON_SIZE_MEDIUM": 2,
                          "BUTTON_SIZE_LARGE": 3
                        }
                      }
                    }
                  },
                  "TextLinkDescription": {
                    "fields": {
                      "text": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "variant": {
                        "type": ".squareup.bbfrontend.common.component.TextLinkDescription.TextLinkVariant",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "TEXT_LINK_VARIANT_DEFERRED"
                        }
                      },
                      "actionKind": {
                        "type": ".squareup.bbfrontend.common.component.TextLinkDescription.TextLinkActionKind",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "TextLinkVariant": {
                        "values": {
                          "TEXT_LINK_VARIANT_DEFERRED": 0,
                          "TEXT_LINK_VARIANT_NORMAL": 1,
                          "TEXT_LINK_VARIANT_DESTRUCTIVE": 2
                        }
                      },
                      "TextLinkActionKind": {
                        "values": {
                          "TEXT_LINK_ACTION_KIND_BUTTON": 0,
                          "TEXT_LINK_ACTION_KIND_LINK": 1
                        }
                      }
                    }
                  },
                  "InputHintDescription": {
                    "fields": {
                      "helper": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "error": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "InputFieldAccessoryDescription": {
                    "fields": {
                      "tooltip": {
                        "type": ".squareup.bbfrontend.common.component.InputFieldAccessoryDescription.Tooltip",
                        "id": 1
                      }
                    },
                    "nested": {
                      "Tooltip": {
                        "fields": {
                          "text": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "accessory": {
                        "oneof": ["tooltip"]
                      }
                    }
                  },
                  "TextInputDescription": {
                    "fields": {
                      "label": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "placeholder": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "hint": {
                        "type": ".squareup.bbfrontend.common.component.InputHintDescription",
                        "id": 3,
                        "rule": "optional"
                      },
                      "leadingAccessory": {
                        "type": ".squareup.bbfrontend.common.component.InputFieldAccessoryDescription",
                        "id": 4,
                        "rule": "optional"
                      },
                      "trailingAccessory": {
                        "type": ".squareup.bbfrontend.common.component.InputFieldAccessoryDescription",
                        "id": 5,
                        "rule": "optional"
                      },
                      "formatter": {
                        "type": ".squareup.bbfrontend.common.component.TextInputFormatter",
                        "id": 6,
                        "rule": "optional",
                        "options": {
                          "default": "FORMATTER_DEFERRED"
                        }
                      },
                      "textContentType": {
                        "type": ".squareup.bbfrontend.common.component.TextInputFieldContentType",
                        "id": 7,
                        "rule": "optional",
                        "options": {
                          "default": "TEXT_INPUT_FIELD_CONTENT_TYPE_DEFERRED"
                        }
                      }
                    }
                  },
                  "SecureTextInputDescription": {
                    "fields": {
                      "label": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "hint": {
                        "type": ".squareup.bbfrontend.common.component.InputHintDescription",
                        "id": 2,
                        "rule": "optional"
                      },
                      "formatter": {
                        "type": ".squareup.bbfrontend.common.component.TextInputFormatter",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": "FORMATTER_DEFERRED"
                        }
                      },
                      "textContentType": {
                        "type": ".squareup.bbfrontend.common.component.TextInputFieldContentType",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": "TEXT_INPUT_FIELD_CONTENT_TYPE_DEFERRED"
                        }
                      }
                    }
                  },
                  "TextInputFormatter": {
                    "values": {
                      "FORMATTER_DEFERRED": 0,
                      "FORMATTER_SSN": 1
                    }
                  },
                  "MoneyInputDescription": {
                    "fields": {
                      "label": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "currencyCode": {
                        "type": ".squareup.common.CurrencyCode",
                        "id": 2,
                        "rule": "optional"
                      },
                      "placeholder": {
                        "type": ".squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "minimum": {
                        "type": ".squareup.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "maximum": {
                        "type": ".squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "hint": {
                        "type": ".squareup.bbfrontend.common.component.InputHintDescription",
                        "id": 6,
                        "rule": "optional"
                      },
                      "leadingAccessory": {
                        "type": ".squareup.bbfrontend.common.component.InputFieldAccessoryDescription",
                        "id": 7,
                        "rule": "optional"
                      },
                      "trailingAccessory": {
                        "type": ".squareup.bbfrontend.common.component.InputFieldAccessoryDescription",
                        "id": 8,
                        "rule": "optional"
                      }
                    }
                  },
                  "BannerDescription": {
                    "fields": {
                      "variant": {
                        "type": ".squareup.bbfrontend.common.component.BannerDescription.BannerVariant",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": "BANNER_VARIANT_DEFERRED"
                        }
                      },
                      "title": {
                        "type": "string",
                        "id": 2
                      },
                      "richTextTitle": {
                        "type": ".squareup.bbfrontend.common.component.RichText",
                        "id": 4
                      },
                      "text": {
                        "type": "string",
                        "id": 3
                      },
                      "richText": {
                        "type": ".squareup.bbfrontend.common.component.RichText",
                        "id": 5
                      }
                    },
                    "nested": {
                      "BannerVariant": {
                        "values": {
                          "BANNER_VARIANT_DEFERRED": 0,
                          "BANNER_VARIANT_INFO": 1,
                          "BANNER_VARIANT_SUCCESS": 2,
                          "BANNER_VARIANT_WARNING": 3,
                          "BANNER_VARIANT_CRITICAL": 4
                        }
                      },
                      "title_content": {
                        "oneof": ["title", "richTextTitle"]
                      },
                      "text_content": {
                        "oneof": ["text", "richText"]
                      }
                    }
                  },
                  "PillDescription": {
                    "fields": {
                      "text": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "icon": {
                        "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                        "id": 2,
                        "rule": "optional"
                      },
                      "variant": {
                        "type": ".squareup.bbfrontend.common.component.PillDescription.PillVariant",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": "PILL_VARIANT_DEFERRED"
                        }
                      },
                      "size": {
                        "type": ".squareup.bbfrontend.common.component.PillDescription.PillSize",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": "PILL_SIZE_DEFERRED"
                        }
                      }
                    },
                    "nested": {
                      "PillVariant": {
                        "values": {
                          "PILL_VARIANT_DEFERRED": 0,
                          "PILL_VARIANT_NORMAL": 1,
                          "PILL_VARIANT_EMPHASIS": 2,
                          "PILL_VARIANT_SUCCESS": 3,
                          "PILL_VARIANT_WARNING": 4,
                          "PILL_VARIANT_CRITICAL": 5,
                          "PILL_VARIANT_ALPHA": 7,
                          "PILL_VARIANT_BETA": 8
                        }
                      },
                      "PillSize": {
                        "values": {
                          "PILL_SIZE_DEFERRED": 0,
                          "PILL_SIZE_NORMAL": 1,
                          "PILL_SIZE_COMPACT": 2
                        }
                      }
                    }
                  },
                  "WebURL": {
                    "fields": {
                      "urlString": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "useSessionBridge": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "DateInputDescription": {
                    "fields": {
                      "label": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "hint": {
                        "type": ".squareup.bbfrontend.common.component.InputHintDescription",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "AddressInputDescription": {
                    "fields": {
                      "isEnabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      },
                      "isCountrySelectionEnabled": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "errorFields": {
                        "type": ".squareup.bbfrontend.common.component.AddressInputDescription.ErrorFieldType",
                        "id": 3,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "ErrorFieldType": {
                        "values": {
                          "ADDRESS_LINE_1": 0,
                          "ADDRESS_LINE_2": 1,
                          "LOCALITY": 2,
                          "ADMINISTRATIVE_DISTRICT_LEVEL_1": 3,
                          "POSTAL_CODE": 4
                        }
                      }
                    }
                  },
                  "InlineStatusDescription": {
                    "fields": {
                      "text": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "style": {
                        "type": ".squareup.bbfrontend.common.component.InlineStatusDescription.InlineStatusStyle",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "INLINE_STATUS_STYLE_DEFERRED"
                        }
                      },
                      "lineLimit": {
                        "type": ".squareup.bbfrontend.common.component.InlineStatusDescription.InlineStatusLineLimit",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": "INLINE_STATUS_LINE_LIMIT_DEFERRED"
                        }
                      },
                      "icon": {
                        "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "InlineStatusLineLimit": {
                        "values": {
                          "INLINE_STATUS_LINE_LIMIT_DEFERRED": 0,
                          "INLINE_STATUS_LINE_LIMIT_SINGLE_LINE": 1,
                          "INLINE_STATUS_LINE_LIMIT_UNLIMITED": 2
                        }
                      },
                      "InlineStatusStyle": {
                        "values": {
                          "INLINE_STATUS_STYLE_DEFERRED": 0,
                          "INLINE_STATUS_STYLE_SUCCESS": 1,
                          "INLINE_STATUS_STYLE_WARNING": 2,
                          "INLINE_STATUS_STYLE_ERROR": 3,
                          "INLINE_STATUS_STYLE_INFO": 4
                        }
                      }
                    }
                  },
                  "IconInfoRowDescription": {
                    "fields": {
                      "primaryText": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "secondaryText": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "leadingIcon": {
                        "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                        "id": 3,
                        "rule": "optional"
                      },
                      "showDivider": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": true
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.ButtonDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.ButtonDescription?.nested?.ButtonStyle && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.ButtonDescription?.nested?.ButtonVariant && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.ButtonDescription?.nested?.ButtonSize && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.TextLinkDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.TextLinkDescription?.nested?.TextLinkVariant && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.TextLinkDescription?.nested?.TextLinkActionKind && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.InputHintDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.InputFieldAccessoryDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.InputFieldAccessoryDescription?.nested?.Tooltip && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.TextInputDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.SecureTextInputDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.TextInputFormatter && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.MoneyInputDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.BannerDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.BannerDescription?.nested?.BannerVariant && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.PillDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.PillDescription?.nested?.PillVariant && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.PillDescription?.nested?.PillSize && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.WebURL && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.DateInputDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.AddressInputDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.AddressInputDescription?.nested?.ErrorFieldType && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.InlineStatusDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.InlineStatusDescription?.nested?.InlineStatusLineLimit && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.InlineStatusDescription?.nested?.InlineStatusStyle && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.IconInfoRowDescription) {
  $root.addJSON(jsonData);
}

/**
 * Configuration for a button component.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=126724%3A293438&t=F7FEEyRf4ee89URW-1">Market - Button</a>
 *
 * SOURCE ButtonDescription @ squareup/bbfrontend/common/component/component.proto at 21:1
 */
export const ButtonDescription = $root.lookupType('squareup.bbfrontend.common.component.ButtonDescription');
fixType(ButtonDescription, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ButtonDescription);
/**
 * SOURCE ButtonStyle @ squareup/bbfrontend/common/component/component.proto at 28:3
 */
ButtonDescription.ButtonStyle = $root.lookupEnum('squareup.bbfrontend.common.component.ButtonDescription.ButtonStyle').values;
/**
 * SOURCE ButtonVariant @ squareup/bbfrontend/common/component/component.proto at 38:3
 */
ButtonDescription.ButtonVariant = $root.lookupEnum('squareup.bbfrontend.common.component.ButtonDescription.ButtonVariant').values;
/**
 * SOURCE ButtonSize @ squareup/bbfrontend/common/component/component.proto at 47:3
 */
ButtonDescription.ButtonSize = $root.lookupEnum('squareup.bbfrontend.common.component.ButtonDescription.ButtonSize').values;
/**
 * Configuration for a text link component.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=127664%3A305316&t=F7FEEyRf4ee89URW-1">Market - Text Link</a>
 *
 * SOURCE TextLinkDescription @ squareup/bbfrontend/common/component/component.proto at 59:1
 */
export const TextLinkDescription = $root.lookupType('squareup.bbfrontend.common.component.TextLinkDescription');
fixType(TextLinkDescription, {
  text: {
    notEmpty: true
  },
  actionKind: {
    required: true
  }
});
Builder.createAndAttachToType(TextLinkDescription);
/**
 * SOURCE TextLinkVariant @ squareup/bbfrontend/common/component/component.proto at 64:3
 */
TextLinkDescription.TextLinkVariant = $root.lookupEnum('squareup.bbfrontend.common.component.TextLinkDescription.TextLinkVariant').values;
/**
 * Used to provide correct accessibility annotations.
 *
 * SOURCE TextLinkActionKind @ squareup/bbfrontend/common/component/component.proto at 76:3
 */
TextLinkDescription.TextLinkActionKind = $root.lookupEnum('squareup.bbfrontend.common.component.TextLinkDescription.TextLinkActionKind').values;
/**
 * Configuration for hints below an input. This can be helper and/or error text.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=31507%3A1054&t=F7FEEyRf4ee89URW-1">Market - Helper</a>
 *
 * SOURCE InputHintDescription @ squareup/bbfrontend/common/component/component.proto at 92:1
 */
export const InputHintDescription = $root.lookupType('squareup.bbfrontend.common.component.InputHintDescription');
fixType(InputHintDescription);
Builder.createAndAttachToType(InputHintDescription);
/**
 * Configuration for input accessories.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0%C2%AE?type=design&node-id=126724-293625&mode=design&t=nMORvDUZLiUVgxVF-0">Market - Input</a>
 *
 * SOURCE InputFieldAccessoryDescription @ squareup/bbfrontend/common/component/component.proto at 101:1
 */
export const InputFieldAccessoryDescription = $root.lookupType('squareup.bbfrontend.common.component.InputFieldAccessoryDescription');
fixType(InputFieldAccessoryDescription);
Builder.createAndAttachToType(InputFieldAccessoryDescription);
/**
 * SOURCE Tooltip @ squareup/bbfrontend/common/component/component.proto at 106:3
 */
InputFieldAccessoryDescription.Tooltip = $root.lookupType('squareup.bbfrontend.common.component.InputFieldAccessoryDescription.Tooltip');
fixType(InputFieldAccessoryDescription.Tooltip);
Builder.createAndAttachToType(InputFieldAccessoryDescription.Tooltip);
/**
 * Configuration for text, and only text, input.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=126724%3A293625&t=F7FEEyRf4ee89URW-1">Market - Input</a>
 *
 * SOURCE TextInputDescription @ squareup/bbfrontend/common/component/component.proto at 115:1
 */
export const TextInputDescription = $root.lookupType('squareup.bbfrontend.common.component.TextInputDescription');
fixType(TextInputDescription, {
  label: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TextInputDescription);
/**
 * Configuration for secure text input (like PIN/Password/Etc).
 * @see <a href="https://www.figma.com/design/BKizTk0NavqV0IZS58rPXk/01-Market-Design-System?node-id=31507-1054&node-type=frame&t=Y5fnUXnq1u2572vK-0">Market - Secure Input</a>
 *
 * SOURCE SecureTextInputDescription @ squareup/bbfrontend/common/component/component.proto at 129:1
 */
export const SecureTextInputDescription = $root.lookupType('squareup.bbfrontend.common.component.SecureTextInputDescription');
fixType(SecureTextInputDescription, {
  label: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SecureTextInputDescription);
/**
 * SOURCE TextInputFormatter @ squareup/bbfrontend/common/component/component.proto at 136:1
 */
export const TextInputFormatter = $root.lookupEnum('squareup.bbfrontend.common.component.TextInputFormatter').values;
/**
 * Configuration for money, and only money, input.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=126724%3A293625&t=F7FEEyRf4ee89URW-1">Market - Input</a>
 *
 * SOURCE MoneyInputDescription @ squareup/bbfrontend/common/component/component.proto at 147:1
 */
export const MoneyInputDescription = $root.lookupType('squareup.bbfrontend.common.component.MoneyInputDescription');
fixType(MoneyInputDescription, {
  label: {
    notEmpty: true
  },
  currencyCode: {
    required: true
  }
});
Builder.createAndAttachToType(MoneyInputDescription);
/**
 * Configuration for a banner element.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=127056-293706&t=WyErUcd04HTzDkYR-4">Market - Banner</a>
 *
 * SOURCE BannerDescription @ squareup/bbfrontend/common/component/component.proto at 226:1
 */
export const BannerDescription = $root.lookupType('squareup.bbfrontend.common.component.BannerDescription');
fixType(BannerDescription);
Builder.createAndAttachToType(BannerDescription);
/**
 * SOURCE BannerVariant @ squareup/bbfrontend/common/component/component.proto at 241:3
 */
BannerDescription.BannerVariant = $root.lookupEnum('squareup.bbfrontend.common.component.BannerDescription.BannerVariant').values;
/**
 * Configuration for a pill element.
 * @see <a href="https://www.figma.com/file/BKizTk0NavqV0IZS58rPXk/Market-1.0?node-id=127056-293706&t=WyErUcd04HTzDkYR-4">Market - Pill</a>
 *
 * SOURCE PillDescription @ squareup/bbfrontend/common/component/component.proto at 258:1
 */
export const PillDescription = $root.lookupType('squareup.bbfrontend.common.component.PillDescription');
fixType(PillDescription, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PillDescription);
/**
 * SOURCE PillVariant @ squareup/bbfrontend/common/component/component.proto at 264:3
 */
PillDescription.PillVariant = $root.lookupEnum('squareup.bbfrontend.common.component.PillDescription.PillVariant').values;
/**
 * SOURCE PillSize @ squareup/bbfrontend/common/component/component.proto at 279:3
 */
PillDescription.PillSize = $root.lookupEnum('squareup.bbfrontend.common.component.PillDescription.PillSize').values;
/**
 * A URL that the client is expected to open in a web browser.
 *
 * SOURCE WebURL @ squareup/bbfrontend/common/component/component.proto at 292:1
 */
export const WebURL = $root.lookupType('squareup.bbfrontend.common.component.WebURL');
fixType(WebURL, {
  urlString: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(WebURL);
/**
 * A date input field.
 *
 * SOURCE DateInputDescription @ squareup/bbfrontend/common/component/component.proto at 302:1
 */
export const DateInputDescription = $root.lookupType('squareup.bbfrontend.common.component.DateInputDescription');
fixType(DateInputDescription, {
  label: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DateInputDescription);
/**
 * Configuration for address input fields.
 *
 * SOURCE AddressInputDescription @ squareup/bbfrontend/common/component/component.proto at 310:1
 */
export const AddressInputDescription = $root.lookupType('squareup.bbfrontend.common.component.AddressInputDescription');
fixType(AddressInputDescription);
Builder.createAndAttachToType(AddressInputDescription);
/**
 * SOURCE ErrorFieldType @ squareup/bbfrontend/common/component/component.proto at 318:3
 */
AddressInputDescription.ErrorFieldType = $root.lookupEnum('squareup.bbfrontend.common.component.AddressInputDescription.ErrorFieldType').values;
/**
 * The configuration for an InlineStatus element.
 * @see <a href="https://www.notion.so/square-seller/Inline-status-08208072576a44d3abfbbf8912f93637">Market - Inline status</a>
 *
 * SOURCE InlineStatusDescription @ squareup/bbfrontend/common/component/component.proto at 331:1
 */
export const InlineStatusDescription = $root.lookupType('squareup.bbfrontend.common.component.InlineStatusDescription');
fixType(InlineStatusDescription, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(InlineStatusDescription);
/**
 * SOURCE InlineStatusLineLimit @ squareup/bbfrontend/common/component/component.proto at 339:3
 */
InlineStatusDescription.InlineStatusLineLimit = $root.lookupEnum('squareup.bbfrontend.common.component.InlineStatusDescription.InlineStatusLineLimit').values;
/**
 * SOURCE InlineStatusStyle @ squareup/bbfrontend/common/component/component.proto at 348:3
 */
InlineStatusDescription.InlineStatusStyle = $root.lookupEnum('squareup.bbfrontend.common.component.InlineStatusDescription.InlineStatusStyle').values;
/**
 * Configuration for a basic row element, consisting of an icon, title, and subtitle.
 * Use for simple informational rows such as feature highlights or benefits.
 * Extending is not recommended – if your row requires more complex layouts or behaviors,
 * define a dedicated, feature-specific component instead.
 *
 * SOURCE IconInfoRowDescription @ squareup/bbfrontend/common/component/component.proto at 417:1
 */
export const IconInfoRowDescription = $root.lookupType('squareup.bbfrontend.common.component.IconInfoRowDescription');
fixType(IconInfoRowDescription);
Builder.createAndAttachToType(IconInfoRowDescription);